const _require = require('lodash'),
  isPlainObject = _require.isPlainObject,
  cloneDeep = _require.cloneDeep;
const _require2 = require('@truqc/content-path'),
  enumerateWildcardPath = _require2.enumerateWildcardPath,
  mutateContentValue = _require2.mutateContentValue;
const _require3 = require('../lib/evaluateSource'),
  evaluateSource = _require3.evaluateSource;

/**
  * @function evalute - evaluate filterObjectBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (object === undefined || !isPlainObject(object)) {
    return undefined;
  }
  let result = {};
  const keep = await evaluateSource(source.keep, content, parentContentPath, transientContext, nativeFunctions);
  if (keep !== undefined && Array.isArray(keep)) {
    keep.forEach(wildcardPath => {
      enumerateWildcardPath(object, wildcardPath, (path, value) => {
        mutateContentValue(path, result, value);
      });
    });
  } else {
    result = cloneDeep(object);
  }
  const remove = await evaluateSource(source.remove, content, parentContentPath, transientContext, nativeFunctions);
  if (remove !== undefined && Array.isArray(remove)) {
    remove.forEach(wildcardPath => {
      enumerateWildcardPath(object, wildcardPath, path => {
        mutateContentValue(path, result, null);
      });
    });
  }
  return result;
};
module.exports = {
  evaluate
};